import React, { FC } from 'react'
import { TooltipProps } from 'react-tooltip'
import styled from 'styled-components'

import { getProjectName } from '../../lib/get-project-name'
import { Tooltip } from '../tooltip'

export type LabelProps = {
  color: string
  text: string
  tooltip?: string
  carId?: string
  tooltipSettings?: TooltipProps
  hidden?: boolean
}

export const Label: FC<LabelProps> = ({
  color = '#fff',
  text,
  tooltip,
  children,
  carId = '',
  tooltipSettings,
  ...restProps
}) => {
  return !tooltip ? (
    <StyledLabel text={text} color={color} {...restProps}>
      <Content>
        {text}
        {children}
      </Content>
    </StyledLabel>
  ) : (
    <>
      <StyledLabel data-tip data-for={text + carId} text={text} color={color} {...restProps}>
        <Content>
          {text}
          {children}
        </Content>
      </StyledLabel>
      <Tooltip id={text + carId} {...tooltipSettings}>
        <span dangerouslySetInnerHTML={{ __html: tooltip }} />
      </Tooltip>
    </>
  )
}

const StyledLabel = styled.div<LabelProps>`
  background-color: ${({ color }) => color};
  vertical-align: baseline;
  line-height: 1;
  outline: none;
  cursor: pointer;
  color: ${() => (getProjectName() === 'avito' ? '#000' : '#fff')};
  padding: ${({ theme }) => {
    if (getProjectName() === 'generic_v2') {
      return '6px 10px'
    }
    return `${theme.spacing[1]} ${theme.spacing[3]}`
  }};
  border-radius: ${() => {
    if (getProjectName() === 'generic_v2') {
      return '100px'
    }
    return '1rem'
  }};
`

const Content = styled.div`
  ${({ theme }) => theme.textStyles.p3};

  font-size: ${() => {
    if (getProjectName() === 'generic_v2') {
      return '14px'
    }
    return '1.2rem'
  }};
`
